import { Map, fromJS } from 'immutable';
import moment from 'moment';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let bets = state.get('offered-betslip') || Map();
    let user = bets.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state
        .setIn([ 'multiples', id ], Map())
        .set('offered-betslip', bets.set(id, user));
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let bets = state.get('offered-betslip') || Map();
    let user = bets.get(id) || Map();

    user = user
        .set('items', Map())
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set('offered-betslip', bets.set(id, user));
}

export function finish(state, { id, result }) {
    id = parseInt(id, 10);

    let bets = state.get('offered-betslip') || Map();
    let user = bets.get(id) || Map();
    let offerExpiresAt = user.getIn([ 'items', 'expiresAt' ])
    let expiresAt = !offerExpiresAt ? moment().add(moment(result.expiresAt).diff(moment(result.when))) : offerExpiresAt;
    user = user.set('items', Map({
        expiresAt: expiresAt
    }))
    .set('state', 'FINISHED')
    .set('errors', void 0);

    return state.set('offered-betslip', bets.set(id, user));
}

export function clear(state) {
    return state.set('offered-betslip', Map());
}
